/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Support_Src_1_NameInputs */

const en_wb_support_src_1_name = /** @type {(inputs: Wb_Support_Src_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your price list`)
};

const lv_wb_support_src_1_name = /** @type {(inputs: Wb_Support_Src_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūsu cenrādis`)
};

/**
* | output |
* | --- |
* | "Your price list" |
*
* @param {Wb_Support_Src_1_NameInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_support_src_1_name = /** @type {((inputs?: Wb_Support_Src_1_NameInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Support_Src_1_NameInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_support_src_1_name(inputs)
	return en_wb_support_src_1_name(inputs)
});